import axios from 'axios';
import ENDPOINTS from 'constants/endpoints.constants';

import APIError from '../exceptions/APIError';

export const getGlobalConfigFetcher = async (cmsSlug: string) => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/tracking-experiences/${cmsSlug}/`;
    const {
      data: { data },
    } = await axios.get(url);

    return data;
  } catch (error) {
    throw new APIError(error.message);
  }
};
